import { AD_TYPES } from "../components/core/blocks/AdPlan/constants";
import type { TSelector } from "../i18n/types";

export const getAdTypeName = (value: number | undefined, channel = "amazon"): TSelector | null => {
  // This avoids walmart SP being labelled as Custom
  if (value === AD_TYPES.CUSTOM.value && channel === "walmart") {
    return AD_TYPES.SPONSORED_PRODUCT.label;
  }

  for (const type in AD_TYPES) {
    const entry = AD_TYPES[type as keyof typeof AD_TYPES];
    if (entry.value === value) {
      return entry.label;
    }
  }

  return null;
};
